// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".inputAnswer{margin-right:15px}", "",{"version":3,"sources":["webpack://./src/styles/AnswerComponent.scss"],"names":[],"mappings":"AAGA,aACI,iBAAA","sourcesContent":[".answerDiv{\r\n}\r\n\r\n.inputAnswer{\r\n    margin-right:15px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
